unable to read source [project]/node_modules/src/ui/scanner/file-selection-ui.ts